import styles from "@styles/containers/cdp/audiences.module.scss";

const Records = ({ records }) => {
	return (
		<div className={styles.records}>
			{records.map((r, index) => {
				const previous = index > 0 ? records[index - 1] : { customers: 0 }
				const diff = r.customers - previous.customers;
				return (
					<div className={styles.record} key={index}>
						<div className={styles.dot} />
						<p className={styles.date}>{r.day}/{r.month}/{r.year}</p>
						<div className={styles.customers}>
							<i className="fas fa-users" />
							<span className={styles.total}>{r.customers} clientes</span>
							<div className={styles.divisor} />
							<div className={styles.growth}>
								<p className={styles.value}>{Math.abs(diff)}</p>
								{ diff > 0 ? (
									<i className="fal fa-arrow-trend-up" />
								) : diff < 0 ? (
									<i className="fal fa-arrow-trend-down" />
								) : (null)}								
							</div>
						</div>
					</div>
				)
			})}
		</div>
	);
};

export default Records;
